export default __webpack_public_path__ + "static/media/televisions-light.6d74f719.svg";